module.exports = "/static/assets/d24599d9a1ea52c40c13a71d8ac26523.gif";